'use strict';

angular.module('magview')
  .controller('TimeManagementCtrl', [
    '$scope', '$state',
    function ($scope, $state) {
      $scope.surroundState = $state.current.name.substring(0, $state.current.name.lastIndexOf('.'));
    }
  ]);
